import { TableRow, styled, tableCellClasses } from '@/core/ui';
export const TableRowStyled = styled(TableRow)(({ theme }) => ({
    [`> .${tableCellClasses.root}`]: {
        padding: theme.spacing(2, 3.5),
    },
}));
